import type { WebPageSection } from "@/lib/api"
import { parseHtmlString } from '@/utils/helpers/html'

interface AboutSectionProps {
  className?: string,
  data: {
    [key: string]: WebPageSection
  }
}

const AboutSection = ({ className, data }: AboutSectionProps) => {
  return (
    <section className={`lg:py-16 py-4 ${className}`}>
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16">
          {/* Main Content */}
          <div className="lg:col-span-2">
            <div className="space-y-6">
              <h1 className="text-4xl font-normal font-pt-serif text-gray-900 leading-[48px]">
                {data.WHO_ARE_WE_ABOUT_AFRICA_SPACE_AGENCY?.title ?? "About Africa Space Agency"}
              </h1>
              
              <div className="space-y-8">
                <p className="font-normal font-satoshi">
                  <span dangerouslySetInnerHTML={parseHtmlString(data.WHO_ARE_WE_ABOUT_AFRICA_SPACE_AGENCY?.description ?? "")} />
                </p>
                
                
              </div>
            </div>
          </div>

          {/* Mission Statement */}
          <div className="lg:col-span-1">
            <div className="bg-wine-200 px-8 py-12 h-fit">
              <div className="space-y-4">
                <h2 className="text-2xl font-normal font-pt-serif text-white leading-7">
                  {data.WHO_ARE_WE_MISSION_STATEMENT?.title ?? "Mission Statement"}
                </h2>
                <p className="font-normal font-pt-serif text-white ">
                  <span dangerouslySetInnerHTML={parseHtmlString(data.WHO_ARE_WE_MISSION_STATEMENT?.description ?? "")} />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutSection